var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: `${_vm.form.id ? "编辑" : "添加"}${_vm.title}`,
        width: 700,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 2 },
            wrapperCol: { span: 22 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "标题", prop: "title" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入标题" },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "a-col",
                { staticStyle: { "padding-left": "3px" }, attrs: { span: 10 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "coverUrl-item",
                      attrs: {
                        label: "图片",
                        prop: "coverUrl",
                        labelCol: { span: 5 },
                        wrapperCol: _vm.itemWrapperCol,
                      },
                    },
                    [
                      _c("j-image-upload", {
                        ref: "coverRef",
                        attrs: {
                          accept: ".png,.jpg,.jpeg",
                          otherData: {
                            compress: 1,
                          },
                          bizPath: "dayOath",
                        },
                        model: {
                          value: _vm.form.coverUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "coverUrl", $$v)
                          },
                          expression: "form.coverUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "coverUrl-item",
                      attrs: {
                        label: "带二维码图片",
                        prop: "url",
                        labelCol: _vm.itemLabelCol,
                        wrapperCol: _vm.itemWrapperCol,
                      },
                    },
                    [
                      _c("j-image-upload", {
                        ref: "coverRef",
                        attrs: {
                          accept: ".png,.jpg,.jpeg",
                          otherData: {
                            compress: 1,
                          },
                          bizPath: "dayOath",
                        },
                        model: {
                          value: _vm.form.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "url", $$v)
                          },
                          expression: "form.url",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }